"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commandWithTextModeFirstArg = exports.color = void 0;
exports.block = block;
exports.arg = arg;
// block() generates a regex fragment that matches a curly-brace-delimited TeX
// block. A block that matches this pattern may have sub-blocks inside it, up
// to a depth of `maxNesting`.
function block(maxNesting) {
    const subnode = maxNesting <= 0
        ? // If no nesting is allowed, a "subnode" of a block is just a
            // non-curly-brace character.
            `[^{}]`
        : // If nesting is allowed, a subnode is either a non-curly-brace
            // character or a block of a lower nesting level.
            `(?:[^{}]|${block(maxNesting - 1)})`;
    // A block consists of a left curly brace, any number of subnodes, and a
    // right curly brace.
    return `\\{${subnode}*\\}`;
}
// arg() generates a regex fragment that matches the most common forms of TeX
// command argument. It matches any of the following:
// - a digit
// - a block (which may have other blocks nested inside it, up to a depth of
//   maxBlockNesting)
// - a letter preceded by whitespace
// TODO(benchristel): if needed, this regex could be generalized to match
// other forms of argument--e.g. a digit preceded by whitespace, a zero-argument
// command like `\pi`, or a non-ASCII character.
function arg(maxBlockNesting) {
    return `(?:\\d|\\s*${block(maxBlockNesting)}|\\s+[A-Za-z])`;
}
// color is a regex fragment that matches the name of a color macro,
// e.g. "purpleD" or "blue". The alphabetic suffix on the color name determines
// how dark the color is.
exports.color = "(?:blue[A-E]?|purple[A-E]?|gold[A-E]|green[A-E]?|maroon[A-E]|red[A-E]?|" +
    "pink|orange|gray[A-I]?|teal[A-E]|mint[A-E]|kaBlue|kaGreen)";
// a regex fragment that matches the name of a command whose first argument
// is parsed in text mode. NOTE: this does NOT match colorbox or fcolorbox,
// because those commands parse their second and third arguments (respectively)
// in text mode.
exports.commandWithTextModeFirstArg = "(?:[fh]box|text(?:|bf|it|normal|rm|sf|tt|up))";
